import { render } from "./Eye.svg?vue&type=template&id=5282d070"
const script = {}
script.render = render

export default script